import React, { useState, useEffect } from 'react'
import {
  Table,
  ButtonGroup,
  IconButton,
  Icon,
  Panel,
  Row,
  Col,
  Grid,
  Tag,
  Avatar,
  Badge,
  Button,
  ControlLabel,
  Input,
  SelectPicker
} from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import AppContext from '../../context/AppContext'
import { useHistory } from 'react-router-dom'
import { budgetFormat } from '../../utils/formatterUtil'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'

export default function ProjectWithdrawReviewDataTable({
  schema,
  onReload,
  pagination,
  lengthMenu,
  onSearchStatus,
  onDownload,
  onShowDetail,
  onShow,
  onChangeShow,
  searchType,
  isApproveSuccess,
  isApproveTable,
  isSaveSuccess,
  statusOptions,
  statusOptionsForApprover
}) {
  const { Column, HeaderCell, Cell } = Table
  const contextValue = React.useContext(AppContext)
  const history = useHistory()
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [status, setSatatus] = useState('all')
  const [expanded, setExpanded] = useState(true)
  const [inputValueCode, setInputValueCode] = useState('')
  const [inputValueName, setInputValueName] = useState('')

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  useEffect(() => {
    setExpanded(onShow)
  }, [onShow])

  useEffect(() => {
    if(isApproveSuccess){
      onSearchStatus(5, 1, 2, inputValueCode, inputValueName)
    }
  }, [isApproveSuccess])

  useEffect(() => {
    if(isSaveSuccess){
      onSearchStatus(5, 1, status, inputValueCode, inputValueName)
    }
  }, [isSaveSuccess])

  const handleChangeLength = (dataKey) => {
    console.log('status => ', status)
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      // if (searchType === 'inputs') {
      //   onReload(dataKey, 1, null, null, null)
      // } else {
      //   onReload(dataKey, 1, status)
      // }
      onReload(dataKey, 1, status, null, null)
    }
  }
  const handleChangePage = (dataKey) => {
    console.log('status => ', status)
    setPage(dataKey)
    if (typeof onReload === 'function') {
      // if (searchType === 'inputs') {
      //   setInputValueCode('')
      //   setInputValueName('')
      //   onReload(displayLength, dataKey, null, null, null)
      // } else {
      //   onReload(displayLength, dataKey, status)
      // }
      onReload(displayLength, dataKey, status, inputValueCode, inputValueName)
    }
  }

  const getData = () => {
    console.log('get data')
    return schema.values?.filter((v, i) => {
      const start = displayLength * (page - 1)
      const end = start + displayLength
      return i >= start && i < end
    })
  }

  const handleChangeStatus = (sta) => {
    // if (searchType === 'inputs') {
    //   onSearchStatus(5, 1, null, inputValueCode, inputValueName)
    // } else {
    //   onSearchStatus(5, 1, sta)
    // }
    onSearchStatus(5, 1, sta, inputValueCode, inputValueName)
  }

  const handleChangeProjectCode = (val) => {
    setInputValueCode(val)
  }

  const handleChangeProjectName = (val) => {
    setInputValueName(val)
  }

  const handleSearchProject = () => {
    onSearchStatus(5, 1, status, inputValueCode, inputValueName)
    setPage(1)
  }

  const handleCancelSearchProject = () => {
    setInputValueCode('')
    setInputValueName('')
    onSearchStatus(5, 1, 'all', null, null)
    setPage(1)
  }

  const ImageCell = ({ rowData, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0 }}>
      <Grid fluid>
        <Row>
          <Col
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{
              width: 40,
              height: 40,
              background: contextValue.theme[0] == 'dark' ? '#515151' : '#f5f5f5',
              borderRadius: 20,
              marginTop: 2,
              overflow: 'hidden',
              display: 'inline-block',
            }}
          >
            <Icon
              icon={rowData[dataKey].icon || ''}
              size={'lg'}
              style={{ marginLeft: 6, marginTop: 10 }}
            />
            {/* <img src={rowData[dataKey]} width="44" /> */}
          </Col>
          <Col lg={12} md={12} sm={12} xs={12} style={{ marginTop: 10 }}>
            {rowData[dataKey].projectType}
          </Col>
        </Row>
      </Grid>
    </Cell>
  )

  const TagCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell {...props} style={{ padding: 0 }}>
        <Row>
          <Col lg={12} style={{ marginTop: 10 }}>
            <Avatar
              style={{
                backgroundColor: rowData[dataKey].code || '',
                width: 90,
                fontSize: 14,
                height: 30,
                fontWeight: 800,
              }}
            >
              {rowData[dataKey].label}
            </Avatar>
          </Col>
        </Row>
      </Cell>
    )
  }

  const renderButtonBadge = (data, index) => {
    let buttonBadge
    buttonBadge = (
      <Badge
        maxCount={9999}
        content={data.countStatus}
        style={{ marginRight: 20, fontWeight: 800 }}
        key={index}
      >
        <Button
          style={{ color: '#fff', backgroundColor: data.colorStatus, fontWeight: 800 }}
          onClick={() => {
            handleChangeStatus(data.status)
            setSatatus(data.status)
            setPage(1)
          }}
        >
          {data.buttonText}
        </Button>
      </Badge>
    )

    return buttonBadge
  }

  return (
    <>
      <Panel
        header={schema.header}
        bordered
        collapsible
        defaultExpanded
        expanded={expanded}
        onSelect={() => onChangeShow()}
      >
        <Grid fluid>
          {/* {searchType === 'inputs' ? ( */}
            <>
              <Row gutter={16}>
                <Col lg={5} md={12} sm={24} xs={24}>
                  <ControlLabel>รหัสโครงการ</ControlLabel>
                  <Input
                    name={'projectcode'}
                    value={inputValueCode}
                    placeholder="ระบุรหัสโครงการ"
                    onChange={handleChangeProjectCode}
                  ></Input>
                </Col>
                <Col lg={5} md={12} sm={24} xs={24}>
                  <ControlLabel>ชื่อโครงการ</ControlLabel>
                  <Input
                    name={'projectname'}
                    value={inputValueName}
                    placeholder="ระบุชื่อโครงการ"
                    onChange={handleChangeProjectName}
                  ></Input>
                </Col>
                <Col xs={24} sm={24} md={12} lg={4}>
                  <ControlLabel>{'สถานะ'}</ControlLabel>
                  <SelectPicker
                      //data={isApproveTable ? statusOptionsForApprover : statusOptions}
                      data={isApproveTable ? statusOptionsForApprover : statusOptions}
                      searchable={false}
                      cleanable={true}
                      value={status}
                      onChange={(value) => {
                        //handleOnChangeStatus(rowData, value)
                        setSatatus(value || 'all')
                      }}
                      //disabledItemValues={getDisabledItem(rowData)}
                      //style={{marginRight: 5}}
                      placeholder="ทั้งหมด"
                      block
                      virtualized={false}
                    />
                </Col>
                <Col lg={10} md={12} sm={24} xs={24}>
                  <div>
                    <br />
                    <SearchButton onClick={handleSearchProject}>ค้นหา</SearchButton>
                    <CancelButton onClick={handleCancelSearchProject}>ยกเลิก</CancelButton>
                    {/* <Button
                      size="sm"
                      color="green"
                      appearance="ghost"
                      style={{ width: 'auto', height: '35px' }}
                      onClick={handleSearchProject}
                    >
                      ค้นหา
                    </Button>
                    &nbsp;&nbsp;&nbsp;
                    <Button
                      size="sm"
                      color="yellow"
                      appearance="ghost"
                      style={{ width: 'auto', height: '35px' }}
                      onClick={handleCancelSearchProject}
                    >
                      ยกเลิก
                    </Button> */}
                  </div>
                </Col>
              </Row>
            </>
          {/* ) : ( */}
            {/* <>
               <Row>
                <div style={{ float: 'right' }}>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <>
                      {schema.buttonFilterStatus &&
                        schema.buttonFilterStatus.map((data, index) => {
                          return renderButtonBadge(data, index)
                        })}
                    </>

                    <Button
                      style={{
                        color: '#000000',
                        backgroundColor: '#EEEEEE',
                        fontWeight: 800,
                        marginRight: 20,
                        fontWeight: 800,
                      }}
                      onClick={() => {
                        handleChangeStatus('all')
                        setSatatus('all')
                        setPage(1)
                      }}
                    >
                      ทั้งหมด
                    </Button>
                  </Col>
                </div>
              </Row>
            </> */}
          {/* )} */}
        </Grid>
        <Col lg={24} md={24} sm={24} xs={24}>
          <Table
            wordWrap
            height={400}
            data={pagination && typeof onReload !== 'function' ? getData() : schema?.values || []}
            style={{ marginTop: 5 }}
          >
            <Column
              //flexGrow={1}
              align="center"
              width={120}
              fixed
            >
              <HeaderCell>
                <span>{schema.projectCodeText}</span>
              </HeaderCell>
              <Cell dataKey="code" />
            </Column>
            <Column
              //flexGrow={1}
              width={searchType === 'inputs' ? 700 : 470}
            >
              <HeaderCell>
                <span>{schema.projectNameText}</span>
              </HeaderCell>
              <Cell dataKey="projectName" />
            </Column>
            <Column
              //flexGrow={1}
              width={160}
            >
              <HeaderCell>
                <span>{schema.projectTypeText}</span>
              </HeaderCell>
              <ImageCell dataKey="type" />
            </Column>
            <Column
              // flexGrow={1}
              width={100}
            >
              <HeaderCell>
                <span>{schema.projectStatusText}</span>
              </HeaderCell>
              <TagCell dataKey="colorstatus" />
            </Column>
            <Column
              // flexGrow={1}
              width={120}
              align="right"
            >
              <HeaderCell>
                <span>{schema.projectBudget}</span>
              </HeaderCell>
              <Cell>
                {(rowData) => {
                  return budgetFormat(rowData.projectBudget)
                }}
              </Cell>
            </Column>
            <Column flexGrow={1} minWidth={238} fixed="right">
              <HeaderCell>
                <span>{schema.projectSlip}</span>
              </HeaderCell>

              <Cell>
                {(rowData) => {
                  return (
                    <Row>
                      <IconButton
                        style={{ marginRight: 5 }}
                        appearance="ghost"
                        icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                        onClick={() => {
                          onShowDetail(rowData)
                          setExpanded(false)
                        }}
                      >
                        แสดง
                      </IconButton>
                      {rowData.status != 1 && searchType != 'inputs' && (
                        <IconButton
                          appearance="ghost"
                          icon={<Icon icon="download" className="bt-gost-icon-radius" />}
                          onClick={() => {
                            onDownload(rowData)
                          }}
                        >
                          ดาวน์โหลด
                        </IconButton>
                      )}
                    </Row>
                  )
                }}
              </Cell>
            </Column>
          </Table>

          {pagination && (
            <TablePagination
              lengthMenu={lengthMenu || defaultLengthMenu}
              activePage={page || defaultPage}
              renderLengthMenu={(lengthMenu) => {
                return (
                  <>
                    {lengthMenu}
                    {`รายการ/หน้า`}
                  </>
                )
              }}
              renderTotal={(total) => {
                return <>{` ทั้งหมด ${total} รายการ`}</>
              }}
              displayLength={displayLength || 5}
              total={schema.totalSize}
              onChangePage={handleChangePage}
              onChangeLength={handleChangeLength}
            />
          )}
          <br />
        </Col>
      </Panel>
    </>
  )
}


// const statusOptions = [
//   {
//     label: 'รอเบิกจ่าย',
//     value: 1
//   },
//   {
//     label: 'รออนุมัติ',
//     value: 2
//   },
//   {
//     label: 'อนุมัติ',
//     value: 3
//   },
//   {
//     label: 'ไม่อนุมัติ',
//     value: 4
//   }
// ]

// const statusOptionsForApprover = [
//   {
//     label: 'รออนุมัติ',
//     value: 2
//   },
//   {
//     label: 'อนุมัติ',
//     value: 3
//   },
// ]